import apiClient from "./axios";

const BASE_PATH = "/v3/contract/vendor-crm";

const LIST_ARRAY_KEYS = ["coop_status", "service_category", "agent_subtype", "airport"];

function serializeListParams(params = {}) {
    const query = { ...params };
    LIST_ARRAY_KEYS.forEach((key) => {
        if (Array.isArray(query[key])) {
            query[key] = query[key].filter(Boolean).join(",");
        }
        if (!query[key]) {
            delete query[key];
        }
    });
    Object.keys(query).forEach((key) => {
        if (query[key] === undefined || query[key] === null || query[key] === "") {
            delete query[key];
        }
    });
    return query;
}

/**
 * 供应商 CRM 前端接口。
 *
 * 字典只有读取，没有写入——一期不提供字典维护页，下拉只能从预置选项里选。
 */
export const vendorCrmApi = {
    getLookups: async () => apiClient.get(`${BASE_PATH}/lookups`),

    listSuppliers: async (params = {}) =>
        apiClient.get(`${BASE_PATH}/suppliers`, { params: serializeListParams(params) }),

    getSupplier: async (partnerId) => apiClient.get(`${BASE_PATH}/suppliers/${partnerId}`),

    createSupplier: async (data) => apiClient.post(`${BASE_PATH}/suppliers`, data),

    updateSupplier: async ({ id, data }) => apiClient.put(`${BASE_PATH}/suppliers/${id}`, data),

    listQualifications: async (partnerId) =>
        apiClient.get(`${BASE_PATH}/suppliers/${partnerId}/qualifications`),

    createQualification: async ({ partnerId, data }) =>
        apiClient.post(`${BASE_PATH}/suppliers/${partnerId}/qualifications`, data),

    updateQualification: async ({ id, data }) => apiClient.put(`${BASE_PATH}/qualifications/${id}`, data),

    revokeQualification: async (id) => apiClient.post(`${BASE_PATH}/qualifications/${id}/revoke`),

    renewQualification: async ({ id, data }) =>
        apiClient.post(`${BASE_PATH}/qualifications/${id}/renew`, data),

    issueQualificationUploadTicket: async ({ partnerId, data }) =>
        apiClient.post(`${BASE_PATH}/suppliers/${partnerId}/qualification-attachments/upload-ticket`, data),

    getQualificationAttachmentUrl: async (id) =>
        apiClient.get(`${BASE_PATH}/qualifications/${id}/attachment-url`),

    listContacts: async (partnerId) => apiClient.get(`${BASE_PATH}/suppliers/${partnerId}/contacts`),

    createContact: async ({ partnerId, data }) =>
        apiClient.post(`${BASE_PATH}/suppliers/${partnerId}/contacts`, data),

    updateContact: async ({ id, data }) => apiClient.put(`${BASE_PATH}/contacts/${id}`, data),

    deactivateContact: async (id) => apiClient.post(`${BASE_PATH}/contacts/${id}/deactivate`),

    getAlerts: async (params = {}) => apiClient.get(`${BASE_PATH}/alerts`, { params }),

    exportSuppliers: async (params = {}) =>
        apiClient.get(`${BASE_PATH}/exports/suppliers`, { params: serializeListParams(params) }),

    listFollowUps: async (partnerId) => apiClient.get(`${BASE_PATH}/suppliers/${partnerId}/follow-ups`),

    createFollowUp: async ({ partnerId, data }) =>
        apiClient.post(`${BASE_PATH}/suppliers/${partnerId}/follow-ups`, data),

    listContracts: async (partnerId) => apiClient.get(`${BASE_PATH}/suppliers/${partnerId}/contracts`),

    issueContractUploadTicket: async ({ partnerId, data }) =>
        apiClient.post(`${BASE_PATH}/suppliers/${partnerId}/contract-scans/upload-ticket`, data),

    attachContractScan: async ({ id, data }) => apiClient.put(`${BASE_PATH}/contracts/${id}/scan`, data),

    getContractScanUrl: async (id) => apiClient.get(`${BASE_PATH}/contracts/${id}/scan-url`),

    listOperationLogs: async (partnerId) =>
        apiClient.get(`${BASE_PATH}/suppliers/${partnerId}/operation-logs`),

    changePartnerType: async ({ partnerId, data }) =>
        apiClient.post(`${BASE_PATH}/suppliers/${partnerId}/partner-type`, data),
};

export default vendorCrmApi;
